import { RootState } from "store/store";

export const toastsSelector = (state: RootState) => state.toasts;
